import axios from 'axios'
import { PageDataResponse, DataArrayResponse,PageResponse } from '../models/PageResponse'
import { AssuranceActivity,DeleteData } from '../models'
import { config } from '../config'
import { CookieHelper } from '../helpers'

const apiUrl = config.API_URL
const version = 1
const headers = { 'Content-Type': 'application/json'}

export default class AssuranceActivityService
{

    protected headers = {}
    protected token = ""

    constructor(token:string | null){
        if(token){
            this.token = token
            this.headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        }
    }

    async getAll(page: number,limit: number,key:string = ""){
        if(!this.token) return null

        let options = {
                headers: this.headers,
                params: {
                    page: page,
                    limit: limit,
                    key: encodeURI(key)
                }
            }
                                                                                        
        const { data }  = await axios.get<PageDataResponse<AssuranceActivity>>(`${apiUrl}/v${version}/assuranceactivities/call`, options )
        
        return data;
    }

    async getAllName(){
        if(!this.token) return null

        let options = {
                headers: this.headers
            }
        
        const { data }  = await axios.get<PageDataResponse<AssuranceActivity>>(`${apiUrl}/v${version}/assuranceactivities/name`, options )
        
        return data;
    }

    async getLimit(){
        if(!this.token) return null

        let options = {
                headers: this.headers
            }
        
        const { data }  = await axios.get<DataArrayResponse<AssuranceActivity>>(`${apiUrl}/v${version}/assuranceactivities/limit`, options )
        
        return data;
    }

    async Search(key:string){
        if(!this.token) return null
        
        let options = {
            headers:this.headers,
            params: {
                key: encodeURI(key)
            }
        }
        const { data }   = await axios.get<DataArrayResponse<AssuranceActivity>>(`${apiUrl}/v1/assuranceactivities/search`,options )
        return data;
    }

    async Create(assuranceActivity: AssuranceActivity){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers: this.headers
        }
        const { data }   = await axios.post<PageResponse>(`${apiUrl}/v${version}/assuranceactivities/call`,JSON.stringify(assuranceActivity),options )
        return data;
    }

    async Update(assuranceActivity: AssuranceActivity){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers:this.headers
        }
        const { data }  = await axios.put<PageResponse>(`${apiUrl}/v${version}/assuranceactivities/call`,JSON.stringify(assuranceActivity),options )
        return data;
    }

    async Delete(id: number,updateBy: string){
        if(!this.token) return null
        
        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers:this.headers
        }

        let deleteData:DeleteData = {
            id:id,
            updateBy:updateBy
        }

        const { data }  = await axios.post<PageResponse>(`${apiUrl}/v${version}/assuranceactivities/delete`,JSON.stringify(deleteData),options )
        return data;
    }

}